export default __webpack_public_path__ + "assets/company1.png";